import { SamlIdpTranslator } from 'src/translators'
import { useSamlIdpQuery } from 'src/types/generated'

export const useGetSamlIdp = () => {
  const { loading, data, error, refetch } = useSamlIdpQuery()
  const samlIdp = data && data.samlIdp ? SamlIdpTranslator.toEntity(data.samlIdp) : undefined
  return { loading, samlIdp, error, refetch }
}
